<template>
  <main>
    <div class="page-check-course">
      <div class="section-frame" v-if="!certificateCheckInfo">
        <ul class="breadcrumbs">
          <li>
            <router-link to="/"><i class="fa-home-line"></i></router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <a>{{ $t("certificate_info") }}</a>
          </li>
        </ul>
        <div class="page-sub-title">
          <h1><i class="fa-title"></i>{{ $t("no_certificate_info_found") }}</h1>
        </div>
        <div class="page-404-frame">
          <router-link to="/" class="arrow-back-404"
            ><i class="fa-arrow-line-back"></i>
            <div v-cyr2lat="$store.getters.lang">
              {{ $t("back") }}
            </div></router-link
          >
          <img src="../assets/images/404.png" class="photo-404" alt="" />
          <router-link to="/" class="back-main-page"
            >{{ $t("go_to_main") }}<i class="fa-arrow-line"></i
          ></router-link>
        </div>
      </div>

      <div class="section-frame" v-else>
        <ul class="breadcrumbs">
          <li>
            <router-link to="/"><i class="fa-home-line"></i></router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <a>{{ $t("certificate_info") }}</a>
          </li>
        </ul>
        <div class="jcc page-sub-title">
          <h1>
            <i class="fa-title"></i>
            {{ $t("confirmed") }}
          </h1>
        </div>
        <p
          v-if="certificateCheckInfo.certificate.is_certificated_course"
          v-cyr2lat="$store.getters.lang"
        >
          {{
            $t("certificate_confirmation_text", {
              user_name: certificateCheckInfo.certificate.user_name,
              date: new Intl.DateTimeFormat("ru-RU").format(
                new Date(certificateCheckInfo.certificate.finished_date),
              ),
              course_name: certificateCheckInfo.certificate.name,
            })
          }}
        </p>
        <p v-else v-cyr2lat="$store.getters.lang">
          {{
            $t("certificate_confirmation_mini_text", {
              user_name: certificateCheckInfo.certificate.user_name,
              date: new Intl.DateTimeFormat("ru-RU").format(
                new Date(certificateCheckInfo.certificate.finished_date),
              ),
              course_name: certificateCheckInfo.certificate.name,
            })
          }}
        </p>
        <a
          :href="certificateCheckInfo.certificate.pdf"
          target="_blank"
          class="back-main-page"
          >{{ $t("view_certificate_link") }}<i class="fa-arrow-line"></i
        ></a>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  title: "Sertifikatni tekshirish",
  data() {
    return {};
  },
  async mounted() {
    await this.$store.dispatch(
      "getCertificateCheckInfo",
      this.$route.params.hash,
    );
    console.log(this.certificateCheckInfo);
  },
  methods: {},
  computed: {
    certificateCheckInfo() {
      return this.$store.getters.getCertificateCheckInfo;
    },
  },
};
</script>
